import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { courseClassroomsService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as courseClassroomsActions from './actions';

export function getCourseClassrooms(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_CLASSROOMS),
    mergeMap(({ payload }) => {
      return courseClassroomsService.getCourseClassrooms(payload).pipe(
        map((res) =>
          courseClassroomsActions.getCourseClassroomsSuccess(
            res.responceObject.records
          )
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
